import axios from "axios";


// const instance = axios.create({ baseURL: "http://192.168.86.124:1024/api" });

const instance = axios.create({ baseURL: "https://api.fdd-xdocsystem.com/api" });


instance.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {

    console.log("Response:", response);
    return response;
  },
  (error) => {
    const {
      response: { data },
    } = error;

    if (data.messageCode === 1113) {
      localStorage.clear();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  },
);

export { instance as axios };
